import { useWorldT } from "../i18n.js";
import { WEATHER_SETTINGS } from "../look/weather.js";
import { setWeatherSetting, useWeatherSetting, weatherNow } from "../look/weatherStore.js";
import { Segmented, SettingRow } from "./SettingsParts.js";

/** The weather block of the settings sheet (`world.weather`): Auto, Clear, Cloudy, Rain, Fog. */
export function WeatherControl() {
  const t = useWorldT();
  const setting = useWeatherSetting();
  return (
    <div
      className="hud-weather"
      data-testid="world-weather"
      data-setting={setting}
      data-state={weatherNow.state}
    >
      <SettingRow label={t("weather.label")} hint={t("weather.hint")} stacked>
        <Segmented
          label={t("weather.label")}
          options={WEATHER_SETTINGS.map((w) => ({
            id: w,
            label: t(`weather.${w}`),
            testId: `weather-${w}`,
            pressed: setting === w,
          }))}
          onPick={(id) => setWeatherSetting(id as (typeof WEATHER_SETTINGS)[number])}
        />
      </SettingRow>
    </div>
  );
}
